import React, { useEffect, useState } from 'react';
import './ApplicantsFooter.css';
import { Button } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const ApplicantsFooter = ({
  isEnableAssociateJob,
  onReceiveProps,
  selectedItems = [],
  component,
}) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    if (selectedItems.length === 0) {
      setIsPopupOpen(false);
    }
  }, [selectedItems]);

  const removeJob = (index) => {
    onReceiveProps(selectedItems[index], 'removeJob');
  };

  return (
    <div className="ApplicantsFooter">
      {component === 'associateJob' && (
        <div className="showJobsContainer">
          {/* Footer with clickable "3 Jobs Selected" */}
          <div className="jobs-selected">
            <span
              className=""
              onClick={() => {
                setIsPopupOpen(!isPopupOpen);
              }}
            >
              {selectedItems.length} Jobs Selected
            </span>
          </div>

          {/* Popup */}
          {isPopupOpen && (
            <div className="popup">
              <div className="popup-header">
                <span className="popup-title">
                  {selectedItems.length} Jobs Selected
                </span>
                <span
                  className="popup-close"
                  onClick={() => {
                    setIsPopupOpen(!isPopupOpen);
                  }}
                >
                  X
                </span>
              </div>
              <div className="popup-body">
                {selectedItems.map((job, index) => (
                  <div key={index} className="job-item">
                    <span>
                      {job.jobCode} - {job.title}
                    </span>
                    <button
                      className="remove-btn"
                      onClick={() => removeJob(index)}
                    >
                      <DeleteIcon
                        style={{ color: 'red', fontSize: '1.3rem' }}
                      />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      <div style={{ marginBottom: '10px', position: 'absolute', right: '0px' }}>
        <Button
          type="button"
          variant="contained"
          size="medium"
          className="applicantFootBtn"
          onClick={(e) =>
            onReceiveProps(
              null,
              component === 'generateMail'
                ? 'Send E-mail'
                : isEnableAssociateJob === true
                  ? 'Continue'
                  : 'Save'
            )
          }
        >
          {component === 'generateMail'
            ? 'Send E-mail'
            : isEnableAssociateJob === true
              ? 'Continue'
              : 'Save'}
        </Button>
        {(component === 'associateJob' || component === 'generateMail') && (
          <Button
            type="button"
            size="medium"
            className="backFootBtn"
            onClick={(e) => onReceiveProps(null, 'Back')}
          >
            Back
          </Button>
        )}
      </div>
    </div>
  );
};

export default ApplicantsFooter;
